import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typewriter from 'typewriter-effect';
import './HomePage.css'
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import pic from './Screen.png';
import cut from './cut.png';


export default function HomePage2() {


  return (





    <div>

      <Grid container spacing={2} className='row container mt-4 m-auto'>
        <section item className='col-md-5 left'>
          <div >

            <div className='text-start forImage'>
              <img src={pic} className='responsive2' alt="" />
            </div>

          </div>
        </section>
        <section item className='col-md-6 right' id='background'>
          <div>

            <Box
              sx={{
                my: 3,
                mx: 4,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <h4 className='name forMobile'>
                Shongkor Talukdar
              </h4>
              <h6 className='typewriter forMobile'>

                <Typewriter

                  onInit={(typewriter) => {
                    typewriter
                      .typeString("Co-founder of Pixel Code Tech Solution")
                      .start()
                  }
                  }
                  options={{
                    autoStart: true,
                  }}

                />
                <Typewriter

                  onInit={(typewriter) => {
                    typewriter
                      .typeString("Marketing Executive at ANProperty")
                      .start()
                  }
                  }
                  options={{
                    autoStart: true,
                  }}

                />

                <Typewriter

                  onInit={(typewriter) => {
                    typewriter
                      .typeString('Web Developer in Education Care')
                      .start()
                  }
                  }
                  options={{
                    autoStart: true,
                  }}

                />
                <div className='forWelcome'>
                  <Typewriter
                    onInit={(typewriter) => {
                      typewriter
                        .typeString("--Welcome You")
                        .start()
                    }
                    }
                    options={{
                      autoStart: true,
                    }}

                  />
                </div>
              </h6>
              <p className='forText'>
                A dedicated and Hardworking person who does best in team settings.I anticipate collaborative learning and hands-on problem-solving, which will improve my technical skills and critical thinking in Computer Science and Engineering.
              </p>
              <div class="mainSkill">
                <h4 className="text-center">My Skills</h4>
                <div class="skills">
                  <span>Python</span>
                  <span>OOP</span>
                  <span>Cloud Service Provider AWS</span>
                  <span>Linux</span>
                  <span>JavaScript</span>
                  <span>ES6</span>
                  <span>ReactJS</span>
                  <span>NodeJS</span>
                  <span>ExpressJS</span>
                  <span>NextJS</span>
                  <span>MongoDB</span>
                  <span>SQL</span>
                  <span>Firebase</span>
                  <span>ReduxJS</span>
                  <span>Rest API</span>
                  <span>WordPress</span>
                  <span>Git</span>

                </div>
              </div>
              <p className='homeFollow'><strong>Follow Me On </strong> <span>
                <Link to="https://github.com/Shongkor" target='blank'><i class="fab fa-github"></i></Link>
                <Link to="https://www.linkedin.com/in/shongkor-talukdar/" target='blank'><i class="fab fa-linkedin"></i></Link>
                <Link to="https://www.facebook.com/shongkor.takukdar/" target='blank'><i class="fab fa-facebook"></i></Link>

              </span></p>
              <section className='d-flex'>
                <Link to="about"><Button variant="outlined" className='seeMoreBtn right'>See More</Button></Link>
                <Link to="contact"><Button variant="outlined" className='seeMoreBtn bg-success text-light left'>Contact Me</Button></Link>
              </section>
            </Box>
          </div>
        </section>



      </Grid>
      <img src={cut} alt="" className='bottomImg' />
    </div>


  );
}